import { Avatar, Typography } from "@mui/material";
import { Box } from "@mui/material";
import profileImage from "../assets/whatsapp.png";

export default function ConversationHeader({widgetConfig}) {
  return (
    <Box
      sx={{
        p: 2,
        top: 0,
        backgroundColor: "#085E56",
        borderRadius: "15px 15px 0px 0px ",
        position: "sticky",
        display: "flex",
        flexDirection: "row",
        justifyContent: "left",
        alignItems: "center",
        zIndex: 2147483647,
      }}
    >
      <Box
        sx={{
          display:'flex',
          flexDirection:'row',
          justifyContent:'left',
          alignItems:'center'
        }}
      >
        <Avatar 
          src={widgetConfig.logo!=="default"?widgetConfig.logo :profileImage} 
          sx={{ 
            mr: 2,
            background: '#FFFFFF',
            width: 45,
            height: 45,
            '& img': {
              objectFit: 'cover',
            }
          }}
        />

        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 700,
            color: "#FFFFFF",
          }}
        >
          {widgetConfig.heading}
        </Typography>
      </Box>
    </Box>
  );
}
